import PhoneBill from '../../assets/phonebill.jpg';
import IconFA from '../../components/icon/icon';
import Button from '../../components/button/button';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

function HPHeader() {
    return (
        <section className='headerHeader'>
            <motion.div 
                className='headerContentContainer'
                initial={{ opacity: 0, x: -50 }} // Startposition
                whileInView={{ opacity: 1, x: 0 }} // Zielposition
                transition={{ duration: 1 }} // Dauer der Animation
                viewport={{ once: true, amount: 0.2 }} // Wird bei 20% Sichtbarkeit ausgelöst
            >
                <h1 className='headerHeading'>Vereinfache mit Yaccount deinen Geschäftsprozess</h1>
                <div className='headerIconContainerWrapper'>
                    <div className='headerIconContainer'>
                        <IconFA iconName='dumbbell' />
                        <p>Stärke dein Kundenmanagement noch heute</p>
                    </div>
                    <div className='headerIconContainer'>
                        <IconFA iconName='boltLightning' />
                        <p>Optimiere deine Angebote und Vorschläge</p>
                    </div>
                    <div className='headerIconContainer'>
                        <IconFA iconName='disease' />
                        <p>Erstelle mühelos professionelle Rechnungen</p>
                    </div>
                </div>
                <div className='headerStartContainer'>
                    <Link to='/register'><Button buttonType='Button' buttonValue='Jetzt ausprobieren' /></Link>
                </div>
            </motion.div>
            <motion.img 
                src={PhoneBill} alt='Phone Bill' className='headerImg'
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true, amount: 0.2 }}
            />
        </section>
    );
}

export default HPHeader;